module.exports = __webpack_public_path__ + "static/media/lds-logo_hu.5e473908.svg";